import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { AboutPage } from "./pages/AboutPage";
import { ContactPage } from "./pages/ContactPage";
import { GalleryPage } from "./pages/GalleryPage";
import { HomePage } from "./pages/HomePage";
import { MakeupPage } from "./pages/MakeupPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ServicesPage } from "./pages/ServicesPage";
import { SpecialsPage } from "./pages/SpecialsPage";
import { StaffPage } from "./pages/StaffPage";
import { WeddingPage } from "./pages/WeddingPage";

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="about-us" element={<AboutPage />} />
        <Route path="about" element={<Navigate to="/about-us/" replace />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="wedding" element={<WeddingPage />} />
        <Route path="make-up" element={<MakeupPage />} />
        <Route path="makeup" element={<Navigate to="/make-up/" replace />} />
        <Route path="specials" element={<SpecialsPage />} />
        <Route path="staff" element={<StaffPage />} />
        <Route path="our-team" element={<Navigate to="/staff/" replace />} />
        <Route path="team" element={<Navigate to="/staff/" replace />} />
        <Route path="photo-gallery" element={<GalleryPage />} />
        <Route path="gallery" element={<Navigate to="/photo-gallery/" replace />} />
        <Route path="contact-us" element={<ContactPage />} />
        <Route path="contact" element={<Navigate to="/contact-us/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
